import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	prebidConfig: {
		height: '100%',
		padding: '2rem'
	},
	heading: {
		fontWeight: '600',
		color: theme.palette.primary.main,
		width: 'fit-content',
		textAlign: 'center',
		padding: 0,
		textAlign: 'left',
		margin: '0 auto !important'
	},
	textField: {
		width: '100%',
		backgroundColor: '#D7DBDD',
		marginTop: '1rem !important'
	},
	prebidOutput: {
		backgroundColor: '#D7DBDD',
		height: '90%',
		borderRadius: '4px',
		boxShadow: ' 0 0 6px rgba(0, 0, 0, 0.4)',
		marginTop: '1rem',
		overflowY: 'scroll !important',
		maxHeight: '80vh',
		textAlign: 'left',
		padding: '2rem'
	}
}));
